import React from 'react';
import {Container} from '@mui/material';

const NotFound = () => (
    <Container />
);

export default NotFound;
